<template>

    <div class="row h-100 justify-content-center align-items-center bg-info text-light">

        <div class="col-sm-8 col-11" v-if="idea">

            <h1>Idea</h1>

            <div class="form-group mt-4">

                <label for="idea_idea">Nombre de la idea</label>

                <input type="text" id="idea_idea" class="form-control" v-model="idea.idea" />

            </div>

            <div class="form-group mt-4">

                <label for="idea_descripcion">Descripción de la idea</label>

                <textarea class="form-control" v-model="idea.descripcion" />

            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set"> Siguiente </button>

        </div>

    </div>

</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            idea: null,
            ...mapGetters(["getIdea"]),
        };
    },
    mounted() {
        this.idea = this.getIdea();
    },
    computed: {
        disabled: function() {
            return this.idea.idea === null || this.idea.descripcion === null;
        },
    },
    methods: {
        set() {
            this.setIdea(this.idea);
            router.push("Idea2");
        },
        ...mapActions(["setIdea"]),
    },
};
</script>

